<div class="logo">
	<ng-container *ngIf="this.user && this.user.user.showdashboard==='0'">
		<a href="#" class="simple-text">
			<div class="logo-img">
				<img src="/assets/img/ring.png" *ngIf="config.env.package == 'shadow'" />
				<img src="/assets/img/report-icon-16.png" *ngIf="config.env.package == 'tires'" />
				<img src="/assets/img/circle.png" *ngIf="config.env.package == 'beauty'" />
			</div>
			<b>V<i class="material-icons">all_inclusive</i> </b>
			<span *ngIf="!navState">v8</span>
		</a>
	</ng-container>
	<ng-container *ngIf="this.user && this.user.user.showdashboard!=='0'">
		<a href="/#/orders/entry" class="simple-text">
			<div class="logo-img">
				<img src="/assets/img/ring.png" *ngIf="config.env.package == 'shadow'" />
				<img src="/assets/img/report-icon-16.png" *ngIf="config.env.package == 'tires'" />
				<img src="/assets/img/circle.png" *ngIf="config.env.package == 'beauty'" />
			</div>
			<b>V<i class="material-icons">all_inclusive</i> </b>
			<span *ngIf="!navState">v8</span>
		</a>
	</ng-container>
</div>
<div class="sidebar-wrapper">
	<div class="menu-search-sidebar-trigger" (click)="openCommandPalette()" title="Search (⌘K)" role="button" tabindex="0" (keydown.enter)="openCommandPalette()" (keydown.space)="openCommandPalette(); $event.preventDefault()">
		<svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
			<circle cx="11" cy="11" r="8"/>
			<path d="m21 21-4.35-4.35"/>
		</svg>
		<span class="menu-search-placeholder">Search or press ⌘K...</span>
	</div>
	<div *ngIf="isMobileMenuActive" class="msearch forced">
		<search class="forced"></search>
	</div>
	<ul class="nav">
		<div class="user">
			<div class="user-info">
				<a data-toggle="collapse" href="#profile" class="" aria-expanded="false" *ngIf="user.user">
					<span>{{ user.user.realname || user.user.userid }} <b class="caret caret-top"></b></span></a>
				<div id="profile" class="collapse " style="">
					<ul class="nav">
						<li class="nav-item">
							<a [routerLink]="'/users/user-profile'" class="nav-link ">
								<span class="sidebar-mini">EP</span>
								<span class="sidebar-normal">Edit Profile</span>
							</a>
						</li>
						<li class="nav-item" *ngIf="config.env.package === 'tires'">
							<a class="nav-link a-align" (click)="togglePrintConnect(activePrintConnect)">
								<span [ngClass]="activePrintConnect ? 'ep-icon ep-status-active sidebar-mini' : 'ep-icon ep-status-disabled sidebar-mini'">
									<svg *ngIf="updatingPrintConnect" class="ep-icon-spinner spinner" width="18px" height="18px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
										<circle class="path" color="white" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
									</svg>
									<mat-icon class="ep-icon-text" *ngIf="activePrintConnect && !updatingPrintConnect">check</mat-icon>
									<mat-icon class="ep-icon-text" *ngIf="!activePrintConnect && !updatingPrintConnect">close</mat-icon>
								</span>
								<span class="sidebar-normal">
									Print-Connect
								</span>
							</a>
						</li>
						<li class="nav-item d-none">
							<a [routerLink]="'/users/user-settings'" class="nav-link">
								<span class="sidebar-mini">S</span><span class="sidebar-normal">Settings</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<li class="nav-item sidebar-pinned-wrap" *ngIf="pinnedItemsForDisplay.length > 0">
			<div class="sidebar-pinned">
				<div class="pinned-header">
					<svg class="pinned-star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
						<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
					</svg>
					<span>PINNED</span>
				</div>
				<div class="pinned-list">
					<a *ngFor="let item of pinnedItemsForDisplay; trackBy: trackByPinnedId" [routerLink]="item.path" class="pinned-item" routerLinkActive="pinned-item--active" [routerLinkActiveOptions]="{exact: false}">
						<span class="pinned-item-label">{{ item.title }}</span>
						<button type="button" class="pinned-unpin" (click)="togglePin(item.id, $event)" aria-label="Unpin">
							<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
								<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
							</svg>
						</button>
					</a>
				</div>
			</div>
		</li>
		<li routerLinkActive="active" class="nav-item" id="parent-favorites">
			<ng-container>
				<a data-toggle="collapse" href="#collapse-favorites" class="nav-link linkback parents" aria-expanded="false" (click)="selectParentMarker('#parent-favorites','#collapse-favorites')">
					<i class="material-icons linkback">star</i>
					<p>Favorites</p>
				</a>
			</ng-container>
			<div id="collapse-favorites" class="children collapse" style="">
				<ul class="nav">
					<ng-container *ngIf="favorites && favorites.length">
						<li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngFor="let item of favorites; trackBy: trackByFaveId">
							<ng-container>
								<a [routerLink]="[item.path]" class="nav-link linkback" *ngIf="!item.children && memoizedPathAllowed(item.path)" (click)="selectMarker('#parent-favorites', '#collapse-favorites')">
									<span class="sidebar-mini linkback f-10">{{ item.icon }}</span>
									<span [title]="item.longtitle ? item.longtitle : item.title" class="sidebar-normal">{{ item.title }} </span>
								</a>
							</ng-container>
						</li>
					</ng-container>
					<li class="nav-item">
						<ng-container>
							<a class="nav-link linkback" (click)="addFavorites()" *ngIf="!isFavoriteRoute">
								<span class="sidebar-mini linkback f-10"><i class="material-icons linkback">add</i></span>
								<span title="Favorites" class="sidebar-normal">Add to Favorites</span>
							</a>
							<a class="nav-link linkback" (click)="removeFavorites()" *ngIf="isFavoriteRoute">
								<span class="sidebar-mini linkback f-10"><i class="material-icons linkback">remove</i></span>
								<span title="Favorites" class="sidebar-normal">Remove Favorite</span>
							</a>
						</ng-container>
					</li>
				</ul>
			</div>
		</li>
		<li routerLinkActive="active" *ngFor="let menuItem of menuItems; trackBy: trackByAnchor" class="{{menuItem.class}} nav-item" id="parent-{{ menuItem.anchor }}">
			<ng-container *ngIf="showMenuItem(menuItem)">
				<a class="nav-link linkback" [routerLink]="[menuItem.path]" *ngIf="!menuItem.children && memoizedPathAllowed(menuItem.path)" (click)="selectMarker('#parent-'+menuItem.anchor,'#parent-'+menuItem.anchor)">
					<i class="material-icons linkback">{{menuItem.icon}}</i>
					<p>{{menuItem.title}}</p>
					<button type="button" class="nav-pin" *ngIf="isPinnablePath(menuItem.path)" [class.nav-pin--pinned]="pinnedSet.has(getItemId(menuItem.path))" (click)="$event.stopPropagation(); $event.preventDefault(); togglePin(getItemId(menuItem.path), $event)" aria-label="Pin">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
					</button>
				</a>
				<a data-toggle="collapse" href="#collapse-{{menuItem.anchor}}" class="nav-link linkback parents" aria-expanded="false" *ngIf="menuItem.children && memoizedPathAllowed(menuItem.path)" (click)="selectParentMarker('#parent-'+menuItem.anchor,'#collapse-'+menuItem.anchor)">
					<i class="material-icons linkback">{{menuItem.icon}}</i>
					<p>{{menuItem.title}}</p>
				</a>
			</ng-container>

			<div id="collapse-{{menuItem.anchor}}" class="children collapse" style="" *ngIf="menuItem.children">
				<ul class="nav">
					<ng-container *ngFor="let item of menuItem.children; trackBy: trackByPath">
					<li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="showChild(item)">
						<a [routerLink]="[item.path]" class="nav-link linkback" *ngIf="!item.children && memoizedPathAllowed(item.path)" (click)="selectMarker('#parent-'+menuItem.anchor, '#collapse-'+menuItem.anchor)">
							<span class="sidebar-mini linkback f-10">{{ item.icon }}</span>
							<span [title]="item.longtitle ? item.longtitle : item.title" class="sidebar-normal">{{ item.title }} </span>
							<button type="button" class="nav-pin" *ngIf="isPinnablePath(item.path)" [class.nav-pin--pinned]="pinnedSet.has(getItemId(item.path))" (click)="$event.stopPropagation(); $event.preventDefault(); togglePin(getItemId(item.path), $event)" aria-label="Pin">
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
							</button>
						</a>
						<a data-toggle="collapse" href="#collapse-{{item.anchor}}" class="nav-link linkback" aria-expanded="false" *ngIf="item.children && memoizedPathAllowed(item.path)" (click)="selectMarker('#parent-'+menuItem.anchor,'#collapse-'+menuItem.anchor)">
							<i class="material-icons linkback thirdlevel">{{item.icon}}</i>
							<p>{{item.title}}</p>
						</a>
						<div id="collapse-{{item.anchor}}" class="collapse" style="" *ngIf="item.children && memoizedPathAllowed(item.path)">
							<ul class="nav">
								<li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-item" *ngFor="let ti of item.children; trackBy: trackByPath">
									<a [routerLink]="[ti.path]" class="nav-link linkback" *ngIf="memoizedPathAllowed(ti.path)" (click)="selectMarker('#parent-'+menuItem.anchor,'#collapse-'+menuItem.anchor)">
										<span class="sidebar-mini linkback f-10">{{ ti.icon }}</span>
										<span [title]="ti.longtitle ? ti.longtitle : ti.title" class="sidebar-normal">{{ ti.title }} </span>
										<button type="button" class="nav-pin" *ngIf="isPinnablePath(ti.path)" [class.nav-pin--pinned]="pinnedSet.has(getItemId(ti.path))" (click)="$event.stopPropagation(); $event.preventDefault(); togglePin(getItemId(ti.path), $event)" aria-label="Pin">
											<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
										</button>
									</a>
								</li>
							</ul>
						</div>
					</li>
					</ng-container>
					<li class="nav-item" *ngIf="getAnchorReports(menuItem.anchor).length || (menuItem.reports && menuItem.reports.length)">
						<a class="nav-link linkback" data-toggle="collapse" href="#collapse-{{menuItem.anchor}}-reports" aria-expanded="false">
							<span class="sidebar-mini linkback"><i class="material-icons linkback thirdlevel">stacked_bar_chart</i></span>
							<span class="sidebar-normal">Reports </span>
						</a>
						<div id="collapse-{{menuItem.anchor}}-reports" class="collapse report-section" style="">
							<ul class="nav">
								<ng-container *ngFor="let ti of (menuItem.reports || []); trackBy: trackByPath">
									<li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-item" *ngIf="ti.bypassReportCatalog || isTitleInReports(ti.title)">
										<a [routerLink]="[ti.path]" class="nav-link linkback" (click)="selectMarker('#parent-'+menuItem.anchor,'#collapse-'+menuItem.anchor)">
											<span class="sidebar-mini linkback f-10">{{ ti.icon }}</span>
											<span class="sidebar-normal">{{ ti.title }} </span>
											<button type="button" class="nav-pin" *ngIf="isPinnablePath(ti.path)" [class.nav-pin--pinned]="pinnedSet.has(getItemId(ti.path))" (click)="$event.stopPropagation(); $event.preventDefault(); togglePin(getItemId(ti.path), $event)" aria-label="Pin">
												<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
											</button>
										</a>
									</li>
								</ng-container>
								<li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-item" *ngFor="let ti of getAnchorReports(menuItem.anchor); trackBy: trackByPath">
									<a [routerLink]="[ti.nglink]" class="nav-link linkback" (click)="selectMarker('#parent-'+menuItem.anchor,'#collapse-'+menuItem.anchor)">
										<span class="sidebar-mini linkback f-10">-</span>
										<span class="sidebar-normal">{{ ti.title }} </span>
										<button type="button" class="nav-pin" *ngIf="isPinnablePath(ti.nglink)" [class.nav-pin--pinned]="pinnedSet.has(getItemId(ti.nglink))" (click)="$event.stopPropagation(); $event.preventDefault(); togglePin(getItemId(ti.nglink), $event)" aria-label="Pin">
											<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
										</button>
									</a>
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</li>
	</ul>
</div>
